import "./style.scss";

import { FC } from "react";
import MenuDesktop from "../MenuDesktop";
import MenuMobile from "../MenuMobile";

interface AsideProps {
    isCollapsed?: boolean;
    setIsCollapsed?: (v: boolean) => void;
}

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

const Aside: FC<AsideProps> = ({ isCollapsed = false, setIsCollapsed }) => {
    return (
        <>
            {isMobile
                ? <MenuMobile />
                : <MenuDesktop isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
            }
        </>
    );
};

export default Aside;
